module.exports = __webpack_public_path__ + "img/5400.13a86369.jpg";